<div class="hpanel margin-bottom-5">
  <div class="panel-heading hbuilt wig-c">
    {{ headerTitle }}
  </div>
  <div class="panel-body">
    <div class="row">
      <div class="col-lg-12">
        <div class="follow-social">
          <a >
            <img src="assets/images/gallery/twitter.png">
          </a>
          <a >
            <img src="assets/images/gallery/facebook.png">
          </a>
          <a >
            <img src="assets/images/gallery/linkedin.png">
          </a>
        </div>
      </div>
    </div>
  </div>
</div>
